export default __webpack_public_path__ + "static/media/logindemo.d86bc915.png";